import component from './component'

export default {
    path: '/certificaciones',
    name: 'certificaciones',
    component: component
}



// WEBPACK FOOTER //
// ./src/components/graduados/certificaciones/index.js